export type VacancyActivityMeta = {
  planRent: number;
  pastRent: number;
  area: number;
  rentQM: number;
  heatingCostsIncluded: "yes" | "no";
  additionalCosts: number;
};

export enum VacancyActionflowIndentifier {
  SelfDisclosure = "vacancy-self-disclosure",
  ApplicantInfo = "vacancy-applicant-info-disclosure",
  Guarantor = "vacancy-guarantor-disclosure",
  RentCoverage = "vacancy-rent-coverage-certificate"
}
